import { render, staticRenderFns } from "./SettingsLang.vue?vue&type=template&id=14f668cf"
import script from "./SettingsLang.vue?vue&type=script&lang=js"
export * from "./SettingsLang.vue?vue&type=script&lang=js"
import style0 from "./SettingsLang.vue?vue&type=style&index=0&id=14f668cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports